import React from "react";

const Label = props => {
	return (
		<div style={props.element.style} className={props.className}>{props.element.label}</div>
	);
};

export default React.memo(Label);
